const projects = [
  {
    name: "Go local frontend",
    description:
      "Go local is a project born to travel and discover places as if you were a local person",
    stack: "Angular, TypeScript, Bootsrap",
    sourceCode: "https://github.com/CarolinaBrazalesSempere/go-local",
    tab: "frontend",
  },
  {
    name: "Go local backend",
    description: "Final project of my Web Dev Application studies",
    stack: "Angular, Spring Boot, SQL",
    sourceCode: "https://github.com/CarolinaBrazalesSempere/go-local-backend",
    tab: "backend",
  },
  {
    name: "Events app",
    description:
      "This is a project done as a student of web development at UNIR. The main goal is manage CRUD and Spring Security",
    stack: "Spring Boot, Spring Security, Thymeleaf, SQL",
    sourceCode: "https://github.com/CarolinaBrazalesSempere/CBS-AD3-Eventos",
    tab: "backend",
  },
  {
    name: "Virtual Cashier",
    description:
      "As a web development student at UNIR, I completed a project that involved emulating a virtual cashier",
    stack: " Spring Boot, SQL, JPA",
    sourceCode: "https://github.com/CarolinaBrazalesSempere/cajero-virtual",
    tab: "backend",
  },
];

export { projects };
